import { Fragment } from 'react';
import { cn } from '@/libs/utils/cn';

interface DealWizardStepsProps {
  labels: readonly string[];
  /** Index of the step in flight; everything before it reads as done. */
  current: number;
}

/** The three steps, in HubSpot's own object order, with the one in flight marked. */
export function DealWizardSteps({ labels, current }: DealWizardStepsProps) {
  return (
    <ol className="flex flex-col gap-2 sm:flex-row sm:items-center">
      {labels.map((label, index) => (
        <Fragment key={label}>
          {index > 0 && (
            <li aria-hidden className="ml-2.5 h-3 w-px bg-border sm:ml-0 sm:h-px sm:flex-1" />
          )}
          <li
            aria-current={index === current ? 'step' : undefined}
            className={cn(
              'flex items-center gap-[7px] whitespace-nowrap text-xs font-semibold',
              index <= current ? 'text-primary-700' : 'text-primary-500',
            )}
          >
            <span
              className={cn(
                'inline-flex size-5 shrink-0 items-center justify-center rounded-full text-[11px] font-bold',
                index < current && 'bg-brand text-primary-default',
                index === current && 'bg-button text-button-foreground',
                index > current && 'bg-neutral-200 text-primary-500',
              )}
            >
              {index + 1}
            </span>
            {label}
          </li>
        </Fragment>
      ))}
    </ol>
  );
}
